import React, { useEffect, useState } from "react";
import styles from "./ProductCard.module.css";
import { FiHeart } from "react-icons/fi";
import { FaHeart } from "react-icons/fa";
import { MdTwoWheeler, MdLocalGasStation, MdOpacity } from "react-icons/md";
import { TbCircle } from "react-icons/tb";
import { Tooltip } from "primereact/tooltip";
import { useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import useCartAPI from "../../../api/useCartAPI";
import { setShowLoginDialog } from "../../../redux/dialogSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  addToCart,
  updateCartQuantity,
} from "../../../features/cart/cartSlice";

import { addToProduct, refreshProductList } from "../../../redux/productSlice";
import { RootState } from "../../../app/store";
import { Product as SimilarProduct } from "../Types/product.types";
import { isLoggedInState, isLoggedOutState } from "../../../redux/userState";
import AccountTypeModal, { AccountType } from "../Login_Page/AccountTypeModal";
import LoginModal from "../Login_Page/LoginModal";
import useHeroAPI from "../../../api/useHeroAPI";

export interface Product {
  product_id: number;
  brand: {
    name: string;
    field1: string;
  };
  cart_item_id?: number | string | null;
  compatible_vehicles: string;
  name: string;
  product_name: any;
  product_price: number;
  product_offer_price: number;
  rating: number;
  reviewCount: number;
  image: string;
  product_feature: {
    product_feature_id: number;
    feature: {
      name: string;
      url: string;
    };
  }[];
  is_wishlist?: boolean;
  document_as_product: [
    {
      document: {
        file_path: string;
      };
    },
  ];
  is_goto?: boolean;
}

interface ProductCardProps {
  product: Product | SimilarProduct;
  toastRef: React.RefObject<Toast>;
  code?: string;
  hideAddToCart?: boolean;
  similar?: boolean;
}
const ProductCard: React.FC<ProductCardProps> = ({
  product,
  toastRef,
  code = "TYRE",
  hideAddToCart = false,
  similar = false,
}) => {
  const { cartSave, cartRemoveItem, cartCount, cartList } = useCartAPI();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { predefinedFunc } = useHeroAPI();

  const [wished, setWished] = useState<boolean>(
    ("is_wishlist" in product ? product?.is_wishlist : false) ?? false,
  );
  const [wishCartItemId, setWishCartItemId] = useState<number | string | null>(
    (product as any)?.cart_item_id ?? null,
  );
  const [wishLoading, setWishLoading] = useState(false);
  const [userId, setUserId] = useState(null) as any;
  const [isShowPrice, setIsShowPrice] = useState(false);
  console.log(isShowPrice, "isShowPrice>>>>>>>>>>>");
  const originalPrice = Number(product?.product_price ?? 0);
  const offerPrice = Number(product?.product_offer_price ?? 0);
  const basePath = process.env.REACT_APP_BASE_PATH;
  const hasDiscount = offerPrice > 0 && offerPrice<originalPrice;
  const [authStep, setAuthStep] = useState<"none" | "accountType" | "login">(
    "none",
  );
  const [selectedAccountType, setSelectedAccountType] =
    useState<AccountType>("customer");
  const [pendingAction, setPendingAction] = useState<
    null | "cart" | "wishlist"
  >(null);

  const discountPercent = hasDiscount
    ? Math.round(((originalPrice - offerPrice) / originalPrice) * 100)
    : 0;

  const isLoggedIn = useSelector(isLoggedInState);
  console.log(isLoggedIn, "isLoggedIn:::::::::::::::");
  const isLoggedOut = useSelector(isLoggedOutState);
  console.log(isLoggedOut, "isLoggedOut:::::::::::::::");

  const compatibleVehicles = (product?.compatible_vehicles || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .replace(/Tyre/gi, code === "BATTERY" ? "Battery" : "Tyre")
    .trim();
  const cartItems = useSelector(
    (state: RootState) => (state as any).cart?.items ?? [],
  );
  const isAddedToCart = cartItems?.some(
    (item: any) => String(item?.product_id) === String(product?.product_id),
  );

  const openViewDetail = (product_id: any) => {
    navigate(`${basePath}productdetails/${product_id}`);
  };

  const handleGoToCart = () => {
    navigate(`${basePath}cart`);
  };

  useEffect(() => {
    const authTokens = JSON.parse(localStorage.getItem("authTokens") || "{}");
    console.log(
      "role:",
      authTokens?.user?.roles,
      "is_show_price:",
      authTokens?.user?.is_show_price,
    );
    setUserId(authTokens?.user?.id);
    if (authTokens?.user?.is_show_price === true) {
      setIsShowPrice(true);
      // setIsHidePrice(true);
    }
  }, [isLoggedIn, isLoggedOut, userId]);
  const requireLogin = () => {
    const authTokens = JSON.parse(localStorage.getItem("authTokens") || "{}");

    if (authTokens?.user?.id) {
      setUserId(authTokens?.user?.id);
      return true; // already logged in
    }

    setAuthStep("accountType");
    return false; // not logged in, caller should stop
  };
  const refreshCartCount = async () => {
    try {
      const payload = {
        is_wishList: false,
        is_user: true,
        product_id: 0,
        created_id: 0,
        service_id: 0,
        variant_id: 0,
      };

      const response: any = await cartCount(payload);

      if (response?.status === 200) {
        dispatch(updateCartQuantity(response?.data?.count ?? 0));
      }
    } catch (error) {
      console.log("Cart Count Error:", error);
    }
  };
  const handleAddToCart = async () => {
    if (!requireLogin()) {
      setPendingAction("cart");
      return;
    }
    // if (!userId) return requireLogin();

    const payload = {
      product_id: product?.product_id,
      item_quantity: 1,
      is_wishList: false,
    };

    const response: any = await cartSave(payload);

    if (response.status === 201) {
      dispatch(addToCart(product));
      dispatch(addToProduct(product));
      // dispatch(refreshProductList());
      await refreshCartCount();

      toastRef.current?.show({
        severity: "success",
        summary: "Success",
        detail: "Product added to cart",
        life: 3000,
      });
    }
  };
  const handleWishlistToggle = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!requireLogin()) {
      setPendingAction("wishlist");
      return;
    }
    if (wishLoading) return;

    const nextWished = !wished;
    setWishLoading(true);

    try {
      let response: any;

      if (nextWished) {
        const payload = {
          product_id: product?.product_id,
          item_quantity: 1,
          is_wishList: true,
        };
        response = await cartSave(payload);
      } else {
        if (!wishCartItemId) {
          toastRef.current?.show({
            severity: "error",
            summary: "Failed",
            detail: "Unable to update wishlist",
          });
          setWishLoading(false);
          return;
        }
        response = await cartRemoveItem(wishCartItemId);
      }

      if (response.status === 201 || response.status === 200) {
        setWished(nextWished);

        if (nextWished) {
          const newId = await fetchWishlistItemId();
          setWishCartItemId(newId);
        } else {
          setWishCartItemId(null);
        }

        toastRef.current?.show({
          severity: "success",
          summary: "Success",
          detail: nextWished ? "Added to wishlist" : "Removed from wishlist",
          life: 2000,
        });
      } else {
        toastRef.current?.show({
          severity: "error",
          summary: "Failed",
          detail: "Unable to update wishlist",
        });
      }
    } catch (err) {
      toastRef.current?.show({
        severity: "error",
        summary: "Failed",
        detail: "Unable to update wishlist",
      });
    } finally {
      setWishLoading(false);
    }
  };
  const fetchWishlistItemId = async () => {
    try {
      const payload = {
        user_id: userId,
        is_wishList: true,
        product_id: product?.product_id,
      };
      const res: any = await cartList(payload);
      const match = res?.data?.data?.find(
        (i: any) => String(i?.product_id) === String(product?.product_id),
      );
      return match?.cart_item_id ?? null;
    } catch (err) {
      console.log("fetchWishlistItemId error:", err);
      return null;
    }
  };

  return (
    <>
      <Toast ref={toastRef} />

      <div className={styles.card}>
        {authStep === "accountType" && (
          <AccountTypeModal
            visible={authStep === "accountType"}
            onHide={() => setAuthStep("none")}
            onSelect={(type) => {
              setSelectedAccountType(type);
              setAuthStep("login");
            }}
          />
        )}

        <LoginModal
          visible={authStep === "login"}
          onHide={() => setAuthStep("none")}
          accountType={selectedAccountType}
          onLoginSuccess={() => {
            const authTokens = JSON.parse(
              localStorage.getItem("authTokens") || "{}",
            );
            setUserId(authTokens?.user?.id);
            setAuthStep("none");

            if (pendingAction === "cart") handleAddToCart();
            if (pendingAction === "wishlist") {
              handleWishlistToggle({ stopPropagation: () => {} } as any);
            }
            setPendingAction(null);
          }}
        />

        {/* Wishlist */}
        <button
          className={styles.wishlistBtn}
          onClick={handleWishlistToggle}
          aria-label="Add to wishlist"
          disabled={wishLoading}
        >
          {wished ? (
            <FaHeart className={styles.heartFilled} size={17} />
          ) : (
            <FiHeart size={17} />
          )}
        </button>

        {/* Image */}
        <div
          className={styles.imageWrapper}
          style={{ display: "flex", cursor: "pointer" }}
        >
          <img
            src={
              product?.document_as_product?.[0]?.document?.file_path ||
              "https://mechmiles.com/not-available.png"
            }
            alt={product.name}
            className={styles.image}
            loading="lazy"
            onClick={() => openViewDetail(product?.product_id)}
          />
        </div>

        <p className={styles.brand}>{product?.brand?.name}</p>

        {/* Info */}
        <div
          className={styles.info}
          style={{ cursor: "pointer" }}
          onClick={() => openViewDetail(product?.product_id)}
        >
          {/* <h3 className={styles.name}>{product?.name}</h3> */}
          <h3 className={styles.name}>
            {(product?.name || product?.product_name || "").toUpperCase()}
          </h3>
          {/* {!isShowPrice && (
            <div className="is-not-showing-price">&#8377; ***</div>
          )}
          {!hidePrice && (
            <div className={styles.priceWrapper}>
              {hasDiscount ? (
                <>
                  <p className={styles.offerPrice}>
                    ₹{offerPrice.toLocaleString("en-IN")}
                  </p>
                  <p className={styles.originalPrice}>
                    ₹{originalPrice.toLocaleString("en-IN")}
                  </p>
                  <span className={styles.discountBadge}>
                    {discountPercent}% OFF
                  </span>
                </>
              ) : (
                <p className={styles.offerPrice}>
                  ₹{originalPrice.toLocaleString("en-IN")}
                </p>
              )}
              <p className={styles.taxText}>(Inc. of Taxes)</p>
            </div>
          )} */}

          {/* <div className={styles.priceWrapper}>
            {!isShowPrice ? (
              <p className={styles.offerPrice}>₹ ***</p>
            ) : hasDiscount ? (
              <>
                <p className={styles.offerPrice}>
                  ₹{offerPrice.toLocaleString("en-IN")}
                </p>

                <p className={styles.originalPrice}>
                  ₹{originalPrice.toLocaleString("en-IN")}
                </p>

                <span className={styles.discountBadge}>
                  {discountPercent}% OFF
                </span>
              </>
            ) : (
              <p className={styles.offerPrice}>
                ₹{originalPrice.toLocaleString("en-IN")}
              </p>
            )} */}
          <div className={styles.priceWrapper}>
            {!isLoggedIn ? (
              // Guest user → always show plain actual price, no offer, no discount badge
              <p className={styles.offerPrice}>
                ₹{originalPrice.toLocaleString("en-IN")}
              </p>
            ) : !isShowPrice ? (
              <p className={styles.offerPrice}>₹ ***</p>
            ) : hasDiscount ? (
              <>
                <p className={styles.offerPrice}>
                  ₹{offerPrice.toLocaleString("en-IN")}
                </p>

                <p className={styles.originalPrice}>
                  ₹{originalPrice.toLocaleString("en-IN")}
                </p>

                <span className={styles.discountBadge}>
                  {discountPercent}% OFF
                </span>
              </>
            ) : (
              <p className={styles.offerPrice}>
                ₹{originalPrice.toLocaleString("en-IN")}
              </p>
            )}

            {/* <p className={styles.taxText}>(Inc. of Taxes)</p> */}
          </div>

          {/* <p className={styles.popupDesc}>{compatibleVehicles || ""}</p> */}
          {/* <p className={styles.popupDesc}> */}
          {/* {compatibleVehicles
    ? compatibleVehicles.split(" ").slice(0, 5).join(" ") +
      (compatibleVehicles.split(" ").length > 5 ? "..." : "")
    : ""}
</p> */}
          {/* <p className={styles.popupDesc}>
  {compatibleVehicles?.split(" ").slice(0, 5).join(" ")}{compatibleVehicles?.split(" ").length > 5 ? "..." : ""}
</p> */}
          {/* <p className={styles.popupDesc}>
            {compatibleVehicles
              ? (() => {
                const maxChars = similar ? 22 : 50;
                return compatibleVehicles.length > maxChars
                  ? `${compatibleVehicles.slice(0, maxChars).toUpperCase()}...`
                  : compatibleVehicles.toUpperCase();
              })()
              : ""}
          </p> */}
          {/* <Tooltip target=".tag-tooltip" /> */}

          {/* <div className={styles.tags}>
            {product?.product_feature?.slice(0, 5).map((item) => (
              <div
                key={item.product_feature_id}
                className={`${styles.tag} tag-tooltip`}
                data-pr-tooltip={item.feature.name}
                data-pr-position="top"
              >
                <img
                  src={item.feature.url}
                  alt={item.feature.name || "N/A"}
                  className={styles.tagIconImage}
                />
              </div>
            ))}
          </div> */}
        </div>

        {/* Actions */}
        {/* <div className={styles.actions}>
          <button
            className={isAddedToCart ? styles.gotocart : styles.addToCart}
            onClick={isAddedToCart ? handleGoToCart : handleAddToCart}
          >
            {isAddedToCart ? "GO TO CART" : "ADD TO CART"}
          </button>
        </div> */}
        {/* Actions */}
        {!hideAddToCart && (
          <div className={styles.actions}>
            <button
              className={isAddedToCart ? styles.gotocart : styles.addToCart}
              onClick={isAddedToCart ? handleGoToCart : handleAddToCart}
            >
              {isAddedToCart ? "GO TO CART" : "ADD TO CART"}
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default ProductCard;
